<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <client-general />
        <client-notes />
        <client-transactions />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Dashboard' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <client-dashboard />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Documents' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-documents />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Bank accounts' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-banks />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Companies' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-companies />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Credit cards' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-credit-cards />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Risk' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-risk />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Actions' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-actions />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Wallets' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <client-wallets />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import ClientGeneral from "./ClientGeneral.vue"
import ClientNotes from "./ClientNotes.vue"
import ClientDashboard from "./ClientDashboard.vue"
import ClientTransactions from "./ClientTransactions.vue"
import ClientDocuments from "./ClientDocuments.vue"
import ClientBanks from "./ClientBanks.vue"
import ClientCreditCards from "./ClientCreditCards.vue"
import ClientRisk from "./ClientRisk.vue"
import ClientActions from "./ClientActions.vue"
import ClientCompanies from './ClientCompanies.vue'
import ClientWallets from './ClientWallets.vue'

export default {
  components: {
    ClientGeneral,
    ClientNotes,
    ClientDashboard,
    ClientTransactions,
    ClientDocuments,
    ClientBanks,
    ClientCreditCards,
    ClientRisk,
    ClientActions,
    ClientCompanies,
    ClientWallets,
  },
  data() {
    return {

    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
